import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { buildQueryString, exportFile, showError } from "../../../utils/utilities";
import { useFormik } from "formik";
import { get, toLower } from "lodash";
import { useTranslation } from "react-i18next";
import { langDate, langMonth } from "../../../utils/properties";
import { Col, Row, DatePicker } from "antd";
import { DownloadOutlined, ClearOutlined } from "@ant-design/icons";
import Button from "../../../components/functional_components/Button/PFButton";
import { setLoading } from "../../../redux/ducks/Loading";
import ExportTimesheet from "../../../services/api/ExportTimesheet";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const TimesheetReportDetail = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const dateFormat = langMonth[toLower(currentLanguage)];

  const formikFilter = useFormik({
    initialValues: {
      month: [],
    },
    validate: (values) => {
      let errors = {};
      if (!values.month) {
        errors.month = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      const obj = {
        startMonth: dayjs(values.month[0], "YYYYMM").format("YYYYMM"),
        endMonth: dayjs(values.month[1], "YYYYMM").format("YYYYMM"),
      };
      const queryString = buildQueryString({}, obj);
      const exportResponse = await ExportTimesheet.downloadTimesheet(queryString.string);
      if (!exportResponse.error) {
        const blob = new Blob([exportResponse]);
        exportFile(blob, "Timesheet-detail.csv");
      } else {
        showError(get(exportResponse, "error.messageCode", "ER000"));
      }
      dispatch(setLoading(false));
    },
  });

  return (
    <div className="filter-container">
      <Row type="flex" justify="space-between">
        <Col lg={6} md={12} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mb-10" htmlFor="month">
              {" "}
              {t("report.filter.rangeMonth")}*
            </label>
          </Row>
          <Row>
            <Col span={20}>
              <RangePicker
                className="w-100"
                picker="month"
                id="month"
                name="month"
                format={dateFormat}
                locale={langDate[`locale_${toLower(currentLanguage)}`]}
                value={formikFilter.values.month}
                onChange={(date) => formikFilter.setFieldValue("month", date)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-1em" justify="end">
        <Col>
          <Button
            isDisabled={!formikFilter.dirty}
            type="secondary"
            currentSize="large"
            clickCallback={formikFilter.resetForm}
            currentIcon={<ClearOutlined className="icon-large" />}
          />
        </Col>
        <Col className="left-margin">
          <Button
            isDisabled={!(formikFilter.dirty && formikFilter.isValid)}
            currentSize="large"
            clickCallback={formikFilter.submitForm}
            currentIcon={<DownloadOutlined className="icon-large" />}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TimesheetReportDetail;
